import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function EducationPage() {
  return <IndustryDetailPage slug="education" />;
}